module.exports = __webpack_public_path__ + "static/img/icon_qrtj@2x.a7b12af2.png";